import { CommonModule } from '@angular/common';
import { NgModule, inject } from '@angular/core';
import { MetagroupsResolver } from 'app/assetgroup/metagroup/metagroups-resolver.service';
import { ScopesResolver } from 'app/assetgroup/scope/scopes-resolver.service';
import { ErrorHandlerService } from 'app/core/error-hanlder.service';
import { AuthenticationService } from 'app/login/authentication.service';
import { QuestionControlService } from 'app/shared/dynamic-form/question-control.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AlertService } from './alert.service';
import { AssetgroupService } from './assetgroup.service';
import { AssetprofileService } from './assetprofile.service';
import { AuthenticationGuardService } from './authentication-guard.service';
import { AuthorizationService } from './authorization.service';
import { MetagroupService } from './metagroup.service';
import { ScopeService } from './scope.service';
import { ValidationService } from './validation.service';

@NgModule({
  imports: [CommonModule],
  declarations: [],
  providers: [
    NgbModal, AuthenticationService, AlertService, ErrorHandlerService, ScopeService,
    MetagroupService, AssetgroupService, AuthenticationGuardService, AssetprofileService,
    QuestionControlService, ScopesResolver, AuthorizationService, ValidationService,
    MetagroupsResolver
  ]
})
export class CoreModule {

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    const parentModule = inject(CoreModule, { optional: true, skipSelf: true })!;

    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in AppModule only');
    }
  }
}
